import React, { useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import * as Components from "./components/all";
import * as Screens from "./screens/SuperAdminScreens/all";

// Blue #1364FC
// Light Blue #F1F4FF
// Gray #707070a8

function App() {
	const [showSidebar, setShowSidebar] = useState(false);
	return (
		<BrowserRouter>
			<div
				className="App 
				bg-[#F8F9FD] 
				h-screen max-h-screen w-full
				overflow-hidden
				flex flex-col
				"
			>
				{/* Navbar */}
				<Components.Navbar
					showSidebar={showSidebar}
					setShowSidebar={setShowSidebar}
				/>

				{/* Main Container */}
				<div
					className="
					relative 
					flex-1 
					flex items-stretch 
					overflow-hidden
					"
				>
					{/* sidebar */}
					<Components.Sidebar
						showSidebar={showSidebar}
						setShowSidebar={setShowSidebar}
					/>

					{/* screen container */}
					<div
						className="Screens
						flex-1
						overflow-hidden
						"
					>
						<Routes>
							{/* DASHBOARD */}
							<Route path="/dashboard" element={<Screens.Dashboard />} />

							{/* REVENUE */}
							<Route path="/revenue" element={<Screens.Revenue />} />
							<Route path="/revenue/ps" element={<Screens.RevenueAllPS />} />
							<Route path="/revenue/ps/:id" element={<Screens.RevenuePS />} />

							{/* TRENDS */}
							<Route path="/trends" element={<Screens.Trends />} />
							<Route path="/trends/ps" element={<Screens.TrendsAllPS />} />
							<Route path="/trends/ps/:id" element={<Screens.TrendsPS />} />

							{/* USERS */}
							<Route path="/users" element={<Screens.Users />} />
							<Route path="/users/user/:id" element={<Screens.User />} />

							{/* PARKING SPACES */}
							<Route
								path="/parkingspaces"
								element={<Screens.ParkingSpaces />}
							/>
							<Route
								path="/parkingspaces/newps"
								element={<Screens.NewParkingSpace />}
							/>
							<Route
								path="/parkingspaces/ps/:id"
								element={<Screens.ParkingSpace />}
							/>

							{/* ADMINS */}
							<Route path="/admins" element={<Screens.Admins />} />
							<Route
								path="/admins/passwordreset/:id"
								element={<Screens.PasswordReset />}
							/>

							{/* SUPPORT */}
							<Route
								path="/customersupport"
								element={<Screens.SupportStaff />}
							/>
							<Route
								path="/customersupport/passwordreset/:id"
								element={<Screens.PasswordReset />}
							/>

							{/* PACKAGES */}
							<Route
								path="/packages"
								element={<Screens.Packages />}
							/>
							<Route
								path="/packages/newps"
								element={<Screens.NewPackage />}
							/>
							<Route
								path="/packages/package/:id"
								element={<Screens.Package />}
							/>

							{/* RATES */}
							<Route
								path="/rates"
								element={<Screens.Rates />}
							/>
							<Route
								path="/rates/ps/:id"
								element={<Screens.RatesPS />}
							/>
						</Routes>
					</div>
				</div>
			</div>
		</BrowserRouter>
	);
}

export default App;
